import React from "react";
import AddItemComponent from "../../components/AddItem";
import { useMutation } from "@tanstack/react-query";
import { useNotification } from "../../../../../context/NotificationProvider";
import { useLocalization } from "../../../../../context/LocalizeContextProvider";
import { useAuth } from "../../../../../context/AuthProvider";
import { postItem } from "../../../../../services/Handlers/MasterItemsService";

import { useHistory } from "react-router-dom";

export default function AddItem() {
  const notification = useNotification();
  const localize = useLocalization();
  const history = useHistory();
  const { userDetail } = useAuth();

  const { isLoading: isLoadingSubmit, mutate: mutateSubmit } = useMutation(
    postItem,
    {
      onSuccess: (res) => {
        if (res.status === 200 || res.status === 201) {
          notification.success(localize.getText("successAddData"));
          history.goBack();
        } else {
          notification.error(
            res?.data?.detail || localize.getText("unknownMessageError")
          );
        }
      },
      onError: (res) => {
        notification.error(localize.getText("unknownMessageError"));
      },
    }
  );

  const handleSubmit = (value) => {
    const data = {
      name: value.name,
      price: value.price,
      category_item_id: value.category_item_id,
      busines_id: userDetail?.businessId,
      active: value.active !== false, // default true if not explicitly set to false
    };
    mutateSubmit(data);
  };

  return (
    <AddItemComponent
      handleSubmit={handleSubmit}
      isLoadingSubmit={isLoadingSubmit}
    />
  );
}
